// NL
export const paintingIndoorNL = {
  id: '50c321b1-609f-4a9e-82cb-84d6ca553ed2',
  identifier: 'painting-indoor',
}

export const paintingOutdoorNL = {
  id: 'd7d4ba70-bf39-4f91-add3-f0e83f688735',
  identifier: 'painting-outdoor',
}
